import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "color-selected",
    name: "select",
    size: "16"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_van_checkbox = _resolveComponent("van-checkbox");
    const _component_van_cell = _resolveComponent("van-cell");
    const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
    return _openBlock(), _createBlock(_component_van_checkbox_group, {
        modelValue: _ctx.realValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.realValue = $event),
        ref: "checkboxGroup",
        max: _ctx.realMax,
        onChange: _ctx.handleGroupChange
    }, {
        default: _withCtx(()=>[
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index)=>{
                    return _openBlock(), _createBlock(_component_van_cell, {
                        key: item.value + index,
                        clickable: "",
                        title: item.title,
                        label: item.desc,
                        "title-class": _ctx.judgeIsCurrent(item) ? 'color-selected' : '',
                        "label-class": "cell-label",
                        onClick: ($event)=>_ctx.handleOptionChange(index)
                    }, {
                        "right-icon": _withCtx(()=>[
                                _createVNode(_component_van_checkbox, {
                                    name: _ctx.realOptionAsValue ? item : item.value,
                                    ref_for: true,
                                    ref: "checkboxes",
                                    "checked-color": "#00bebe"
                                }, {
                                    icon: _withCtx(()=>[
                                            _withDirectives(_createElementVNode("pg-icon", _hoisted_1, null, 512), [
                                                [
                                                    _vShow,
                                                    _ctx.judgeIsCurrent(item)
                                                ]
                                            ])
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "name"
                                ])
                            ]),
                        _: 2
                    }, 1032, [
                        "title",
                        "label",
                        "title-class",
                        "onClick"
                    ]);
                }), 128))
            ]),
        _: 1
    }, 8, [
        "modelValue",
        "max",
        "onChange"
    ]);
}
